export default __webpack_public_path__ + "static/media/lumicko-logo.421634ad.png";